/**
 * Checks if chart data has values to display
 * @param {Object} data
 * @return {boolean} True if there is data to display
 */
export const hasValues = (data) => data && data.series && data.series.some((s) => s.values.length);

/**
 * Toggle chart and empty state box visibility
 * @param {HTMLElement} element
 * @param {boolean} showChart - When true the chart is visible, empty state is hidden
 */
export const toggleChartVisibility = (element, showChart) => {
  for (const childElem of element.children) {
    if (childElem.classList.contains('empty-state')) {
      childElem.style.display = showChart ? 'none' : '';
    } else {
      childElem.style.display = showChart ? '' : 'none';
    }
  }
};
